import { BodyText } from '@block-explorer/ui';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => ({
  padding: 14,
  minWidth: 200,
  textAlign: 'center',
  background: theme.styleguideColors.backgroundTertiary,
  borderRadius: theme.borderRadius.base,
  marginBottom: 24,
}));

const SuccessText = styled(BodyText)(({ theme }) => ({
  color: theme.styleguideColors.contentOnFill,
}));

/* eslint-disable-next-line */
export interface AlertProps {
  options: {
    type: 'success' | 'info' | 'error';
  };
  message: string;
}

export function AlertNotificationTemplate({ options, message }: AlertProps) {
  const { type } = options;

  return (
    <Container>
      {type === 'success' && <SuccessText size={1}>{message}</SuccessText>}
    </Container>
  );
}

export default AlertNotificationTemplate;
